module.exports = __webpack_public_path__ + "static/media/boat.60bf4758.jpg";